import gql from 'graphql-tag';

export const GET_MERCHANT_CN_STATUS = gql`
  fragment transactions on TransactionEvents {
    day
    count
  }

  query getMerchantCNStatus(
    $cnInput: CardNetworkInput!
    $reportInput: ReportInput!
  ) {
    cnTransactionsByMarketplace(params: $cnInput) {
      DOSH {
        AMEX {
          ...transactions
        }

        VISA {
          ...transactions
        }

        MASTERCARD {
          ...transactions
        }
      }
    }
    transactionSummary(params: $reportInput) {
      result {
        avgAov
        totalTransactionAmount
        numberOfTransactions
      }
    }
  }
`;
